import { render, staticRenderFns } from "./ModuleOne.vue?vue&type=template&id=1007c342&scoped=true"
import script from "./ModuleOne.vue?vue&type=script&lang=js"
export * from "./ModuleOne.vue?vue&type=script&lang=js"
import style0 from "./ModuleOne.vue?vue&type=style&index=0&id=1007c342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1007c342",
  null
  
)

export default component.exports